export const getInstrument = (state, res) => {
  state.instruments = res
}

export const listInstrument = (state, val) => {
  state.lists = val
}

export const instrumentForm = (state, val) => {
  state.instrument = val
}
